//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

export enum WbDeliveryType {
  /** Fulfillment by Wildberries (хранение и логистика полностью за маркетплейсом). */
  FBW = 0,
  /** Fulfillment by Seller (хранение на складе продавца, но логистика от Wildberries). */
  FBS = 1,
  /** Delivery by Seller (Продавец самостоятельно хранит товар и организует доставку). */
  DBS = 2,
  /** Delivery by Wildberries courier (Доставка курьером WB) = DBW. */
  WbGo = 3,
  /** Express Delivery by Seller (Экспресс доставка продавцом). */
  eDBS = 4,
  /** Самовывоз из магазина продавца. */
  ClickCollect = 5
}
